import { render, staticRenderFns } from "./loginCustomerAndJPUTStaff.vue?vue&type=template&id=7835125c&scoped=true&"
import script from "./loginCustomerAndJPUTStaff.vue?vue&type=script&lang=js&"
export * from "./loginCustomerAndJPUTStaff.vue?vue&type=script&lang=js&"
import style0 from "./loginCustomerAndJPUTStaff.vue?vue&type=style&index=0&id=7835125c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7835125c",
  null
  
)

export default component.exports